import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function PercentageOfOwnershipInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is your ownership percentage?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Your percentage of ownership determines how your rental income,
          expenses, and deductions can be allocated on your tax return.
        </p>
        <p>Where can you find your percentage?</p>
        <ul>
          <li>Your property deed</li>
          <li>Your closing or settlement papers</li>
          <li>
            Your LLC operating agreement (if you own the property through an
            LLC)
          </li>
        </ul>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Publication 527 (2024), Residential Rental Property',
              url: 'https://www.irs.gov/publications/p527',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
